import { action, extendObservable } from 'mobx'
import { extractResponse, extractError } from '../../service/response.service'
import debounce from 'lodash/debounce'
import pick from 'lodash/pick'
import set from 'lodash/set'
import omit from 'lodash/omit'
import history from '../../service/history.service'
import { api } from '../../service/api.service'

class FaqCategoryStore {
  constructor () {
    extendObservable(this, {
      faqCategories: [],
      model: {},
      error: null,
      page: 1,
      count: 0,
      loading: false,
      query: '',
      dragDisabled: false,
      formSubmittedSuccessfully: false
    })

    this.debouncedGetAll = debounce(this.getAll, 300)
  }

  getAll (includeFaqQuestions = false) {
    this.loading = true
    return api.get(`/faq-categories?q=${this.query}&includeFaqQuestions=${includeFaqQuestions}`)
      .then(res => {
        const { count, rows } = res.data
        this.faqCategories = rows
        this.count = count
      })
      .catch(err => {
        this.error = extractError(err)
      })
      .finally(() => {
        this.loading = false
      })
  }

  async findOne (id) {
    const includeFaqQuestions = true
    if (this.faqCategories.length === 0) await this.getAll(includeFaqQuestions)
    return this.faqCategories.find(category => category.id === id)
  }

}
export default new FaqCategoryStore()
